<template><svg viewBox="0 0 48 48" width="48" height="48" xmlns="http://www.w3.org/2000/svg">
  <g fill="currentColor" fill-rule="evenodd">
    <path d="M12.371 8.912L38.72 35.26a2 2 0 1 1-2.828 2.828L9.543 11.74a2 2 0 1 1 2.828-2.828z" />
    <path d="M35.89 9.321L9.544 35.67a2 2 0 1 0 2.828 2.829L38.72 12.15a2 2 0 1 0-2.828-2.829z" />
  </g>
</svg>
</template>